import { render } from "./ShopAccount.vue?vue&type=template&id=5506072d"
import script from "./ShopAccount.vue?vue&type=script&lang=js"
export * from "./ShopAccount.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__